// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__IryYE","layoutContent":"Layout_layoutContent__IxPz3"};